export * from './validators';
import * as CryptoJS from 'crypto-js';

let keySize = 128;
let ivSize = 16;
let iterations = 1000;
let portalpassword = 'C@LOnl1n3S3rvesY0urD1g1t4lN33ds';

export function getEncripted(password) {
  return encrypt(password, portalpassword);
}
function encrypt(msg, pass) {
  // console.log(msg);
  let salt = CryptoJS.lib.WordArray.random(16);

  let key = CryptoJS.PBKDF2(pass, salt, {
    keySize: keySize / 32,
    iterations: iterations,
  });

  let iv = CryptoJS.lib.WordArray.random(16);

  let encrypted = CryptoJS.AES.encrypt(msg, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  // salt, iv will be hex 32 in length
  // append them to the ciphertext for use  in decryption
  let transitmessage = salt.toString() + iv.toString() + encrypted.toString();
  // console.log(transitmessage);
  return transitmessage;
}
